import * as React from 'react';

interface Props {
  className: string;
  title: string | null;
  children: React.ReactNode;
}

const Main: React.FC<Props> = ({className, title, children}) => {
  const globalClass = 'gl ' + className ?? '';
  return (
    <div className={globalClass}>
      {title && <h2>{title}</h2>}
      {children}
    </div>
  );
};
export default Main;
